import React from 'react';
import { Store, Mail, Phone, MapPin } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300 pt-16 pb-8">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Logo e Descrizione */}
          <div>
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-12 h-12 rounded-full bg-gradient-to-br from-teal-400 to-purple-500 flex items-center justify-center">
                <Store className="w-6 h-6 text-white" strokeWidth={2.5} />
              </div>
              <div>
                <h3 className="text-xl font-bold text-white">VeCo Shop</h3>
                <p className="text-xs text-gray-400">Community</p>
              </div>
            </div>
            <p className="text-sm text-gray-400 leading-relaxed mb-4">
              VeCo – Il vantaggio di far parte della rete
            </p>
            <p className="text-sm font-semibold text-teal-400">
              La tessera che ti protegge
            </p>
          </div>

          {/* Link Utili */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-6">Link Utili</h4>
            <ul className="space-y-3">
              <li>
                <a href="#home" className="text-sm hover:text-teal-400 transition-colors">
                  Home
                </a>
              </li>
              <li>
                <a href="#activities" className="text-sm hover:text-teal-400 transition-colors">
                  Attività Convenzionate
                </a>
              </li>
              <li>
                <a href="#come-funziona" className="text-sm hover:text-teal-400 transition-colors">
                  Come Funziona
                </a>
              </li>
              <li>
                <a href="#regolamento" className="text-sm hover:text-teal-400 transition-colors">
                  Regolamento
                </a>
              </li>
              <li>
                <a href="#veco-point" className="text-sm hover:text-teal-400 transition-colors">
                  VeCo Point
                </a>
              </li>
            </ul>
          </div>

          {/* Contatti */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-3">ReBon S.r.l.</h4>
             P.IVA: 07167050488<br />
            <div className="space-y-4">
              <div className="flex items-start">
                <MapPin className="w-5 h-5 text-teal-400 mr-3 mt-0.5 flex-shrink-0" />
                <div className="text-sm">
                  <p>Via Jacopo Carrucci 46</p>
                  <p>50053 Empoli (FI)</p>
                </div>
              </div>
              <div className="flex items-center">
                <Phone className="w-5 h-5 text-teal-400 mr-3 flex-shrink-0" />
                <a href="tel:+390571165700" className="text-sm hover:text-teal-400 transition-colors">
                  +39 0571 1657000
                </a>
              </div>
              <div className="flex items-center">
                <Mail className="w-5 h-5 text-teal-400 mr-3 flex-shrink-0" />
                <a href="mailto:info@vetrinaconsulenti.it" className="text-sm hover:text-teal-400 transition-colors">
                  info@vetrinaconsulenti.it
                </a>
              </div>
              <div className="mt-6">
                <a
                  href="https://www.vetrinaconsulenti.it"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-teal-400 hover:text-teal-300 transition-colors font-medium"
                >
                  www.vetrinaconsulenti.it →
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-gray-500">
              © {new Date().getFullYear()} ReBon srl. Tutti i diritti riservati.<br />
              <a href="https://www.rebon.it/privacy-policy" target="_blank" rel="noreferrer" className="text-gray-400 hover:text-white text-sm transition-colors">
              Privacy Policy</a> - <a href="https://www.rebon.it/cookie-policy" target="_blank" rel="noreferrer" className="text-gray-400 hover:text-white text-sm transition-colors">
              Cookie Policy
            </a>
            </p>
            <div className="flex items-center space-x-4">
              <p className="text-sm text-gray-500">
                VeCo Shop Community • Powered by ReBon S.r.l.
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};